import React, { useState } from 'react';
import { Card, Form, Input, Button, Space, Alert, Select } from 'antd';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { createChatQuestion } from '../../store/slices/chatQuestionSlice';

const CreateChatQuestion = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("success");
    const onSubmit = async (values) => {
        setLoading(true);
        setAlertMessage("");
        try {
            await new Promise(resolve => setTimeout(resolve, 1000));
            const resultAction = await dispatch(createChatQuestion(values))

            if (createChatQuestion.fulfilled.match(resultAction)) {
                setAlertMessage(resultAction?.payload?.message || 'Chat question created successfully');
                setAlertType('success');
                form.resetFields();
                setTimeout(() => {
                    setAlertMessage('')
                }, 4000)
            } else {
                console.log(resultAction?.payload)
                setAlertMessage(resultAction?.payload?.error || 'Error creating chat question');
                setAlertType('error');
            }
        } catch (error) {
            setAlertMessage('Error creating chat question.');
            setAlertType('error');
            console.log(error)
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <h1 style={{ marginBottom: 24 }}>Agent</h1>
            <Card title="Add Chat Question" style={{ marginBottom: 16 }}>
                {alertMessage && (
                    <Alert
                        message={alertMessage}
                        type={alertType}
                        showIcon
                        icon={alertType === 'success' ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                        closable
                        onClose={() => setAlertMessage('')}
                        style={{
                            marginBottom: 24,
                            borderRadius: '8px',
                        }}
                    />
                )}
                <Form
                    layout="vertical"
                    onFinish={onSubmit}
                    form={form}
                >
                    <Form.Item
                        label="Question"
                        name="question"
                        rules={[{ required: true, message: 'Please input question!' }]}
                    >
                        <Input placeholder="Enter question" />
                    </Form.Item>
                    <Form.Item
                        label="Type"
                        name="type"
                        rules={[
                            { required: true, message: 'Please select type' },
                        ]}
                    >
                        <Select
                            options={[
                                { value: '', disabled : true, label: <span>Select Type</span> },
                                { value: 'user', label: <span>User</span> },
                                { value: 'agent', label: <span>Agent</span> },
                            ]}
                        />
                    </Form.Item>
                    <Form.Item>
                        <Space>
                            <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                            size="large"
                            block
                            style={{
                                height: '48px',
                                fontSize: '16px',
                                fontWeight: 600,
                                borderRadius: '8px',
                            }}
                            >
                                Save Changes
                            </Button>
                            <Button onClick={(e) => navigate(-1)}>Back</Button>
                        </Space>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
};

export default CreateChatQuestion;